import { render, staticRenderFns } from "./NotificacionPafi.vue?vue&type=template&id=02730eba&scoped=true"
import script from "./NotificacionPafi.vue?vue&type=script&lang=js"
export * from "./NotificacionPafi.vue?vue&type=script&lang=js"
import style0 from "./NotificacionPafi.vue?vue&type=style&index=0&id=02730eba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02730eba",
  null
  
)

export default component.exports